<template>
  <cv-code-snippet
    ref="snippetRef"
    class="sls-code-snippet"
    :class="`color-${props.color ?? ''}`"
    @copy="handleCopy"
  >
    <slot />
  </cv-code-snippet>
</template>

<script setup lang="ts">
import { useTemplateRef } from "vue";

type Color = "grey" | "white";

const props = defineProps<{
  color?: Color;
}>();

const snippetRef = useTemplateRef("snippetRef");

const handleCopy = async () => {
  if (snippetRef.value) {
    const codeSnippet = snippetRef.value.$el.querySelector("code .ellipsis-text");
    if (codeSnippet) {
      try {
        const originalText = codeSnippet.innerText;
        // SLSSIT-19147: cater for mobile Chrome browser, remove trailing %0A in copied url
        const cleanedText = originalText.replace(/%0A$/, "");
        await navigator.clipboard?.writeText(cleanedText);
      } catch (error) {
        console.error("Failed to copy text: ", error);
      }
    }
  }
};
</script>
<style lang="scss">
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";
.sls-code-snippet {
  //Override carbon max-width
  max-width: 100%;
  &.color-grey {
    background-color: $field-02;
  }
  &.color-white {
    background-color: $ui-01;
    .bx--copy-btn {
      background-color: $ui-01;
    }
  }
}
</style>
